"use strict";
import { MenuLink } from "components/NavBar/CompanyMenu/MenuDropdown";
import { NavDropdown } from "components/NavBar/NavDropdown";
import { getSettingsViewIndex } from "components/NavBar/PreferencesMenu";
import { PreferencesView } from "components/NavBar/PreferencesMenu/shared";
import { useRef, useState } from "react";
import { useMobileMenuContent } from "./Content";
import { AnimateTransition, Flex } from "ui/src";
import { TestID } from "test/fixtures/testIDs";
export function MobileMenuDrawer({ isOpen, closeMenu }) {
  const [settingsView] = useState(PreferencesView.SETTINGS);
  const dropdownRef = useRef(null);
  const items = useMobileMenuContent();
  return <NavDropdown dropdownRef={dropdownRef} isOpen={isOpen} dataTestId={TestID.CompanyMenuMobileDrawer}>
      <Flex pt="$spacing12" pb="$spacing32" px="$spacing24">
        <AnimateTransition
    currentIndex={getSettingsViewIndex(settingsView)}
    animationType={settingsView === PreferencesView.SETTINGS ? "forward" : "backward"}
  >
          <Flex gap="$spacing2" mb="$spacing60">
            {items.map((item) => <MenuLink
    key={`${item.title}_${item.href}`}
    title={item.title}
    href={item.href}
    icon={item.icon}
    isActive={item.isActive}
    internal
    closeMenu={closeMenu}
  />)}
          </Flex>
        </AnimateTransition>
      </Flex>
    </NavDropdown>;
}
